import { useState } from 'react';
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Calendar } from 'lucide-react'

const ProjectList = () => {
  const { projects } = useSelector((state) => state.projectList || { projects: [] })
  const [activeTab, setActiveTab] = useState('active');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  }

  const filteredProjects = () => {
    switch (activeTab) {
      case 'active':
        return projects.filter(project => !project.archived && project.percentageCompleted < 100);
      case 'done':
        return projects.filter(project => project.percentageCompleted === 100);
      case 'archived':
        return projects.filter(project => project.archived);
      default:
        return projects;
    }
  }

  const ProjectStatus = (project) => {
    return (
      <span className={`text-xs px-2 py-1 rounded-3xl ${
        project.step === "in_progress" ? "bg-blue-100 text-blue-800" : "bg-slate-200 text-gray-800"
      }`}>
        {project.percentageCompleted === 100 ? "Done" : project.step.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
      </span>
    )
  }

  return (
    <div className='p-4 overflow-y-auto'>
      <h1 className='text-2xl font-bold mb-4'>Projects</h1>

      {/* Tabs */}
      <div className="flex space-x-4 justify-between mb-4 overflow-x-auto py-2">
        <div className="flex justify-start gap-3">
          {['active', 'done', 'archived'].map((tab) => (
            <button
              key={tab}
              onClick={() => handleTabClick(tab)}
              data-amp-track-section="Project List"
              data-amp-track-action="Filter_Project_Click"
              data-amp-track-description={`${tab.charAt(0).toUpperCase() + tab.slice(1)} Filter Click`}
              className={`flex flex-row items-center justify-start text-md font-semibold whitespace-nowrap gap-2 ml-0 px-2 py-2 border-solid border rounded-3xl border-stone-300 
                ${activeTab === tab 
                  ? ' text-white bg-stone-600 hover:bg-stone-500' 
                  : 'text-stone-600 bg-transparent hover:bg-sky-500 hover:text-white'}`}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {filteredProjects().reverse().map((project) => (
        <div key={project.id} className="border-t border-slate-200 py-3 last:border-b-0">
          {activeTab !== 'done' && (
            <div className="bg-stone-100 rounded-md w-full mb-2">
              {(project.step !== 'gathering_info' && project.step !== 'creating_tasks') && (
                <div
                  className="bg-green-400 text-white text-xs font-medium text-center p-0 leading-none rounded-md"
                    style={{
                      width: `${project.percentageCompleted}%`,
                    }}
                  >
                    <span className='text-xs pl-2'>
                      {project.percentageCompleted}%
                    </span>
                </div>
              )}
            </div>
          )}

          {/* Project Title and Description */}
          <Link to={`/project/${project.id}`}
            data-amp-track-section="Project List"
            data-amp-track-action="View_Project_Click"
            data-amp-track-description="View Project"
          >
            <h3 className="text-lg font-semibold">{project.title}</h3>
            <p className="text-sm text-gray-600">{project.description.substring(0, 200)}...</p>
          </Link>

          <div className="flex items-center mt-2 pb-4 space-x-2">
            <Calendar className="w-4 h-4 text-gray-400" />
            <span className="text-sm text-gray-600">{new Date(project.dueDate).toLocaleDateString()}</span>
            {ProjectStatus(project)}
          </div>
        </div>
      ))}
    </div>
  )
}

export default ProjectList